import { SnackbarProgrammatic as Snackbar } from 'buefy';
import { router } from '@/router';

// TODO: We should look into unifying the way we handle errors
// from the API between this interceptor and the showError mixin
const ApiErrorInterceptor = {
    errorResponse(error) {
        if (error.response && error.response.status === 408)
            Snackbar.open({
                duration: 5000,
                message: '<p>There was a problem connecting to common library.</p>Please try to reload the page',
                actionText: 'reload',
                position: 'is-top',
                type: 'is-danger',
                onAction: () => window.location.reload()
            });

        // Covers users losing their roles while the application is open.
        if (error.response && error.response.status === 403 && !window.authService.hasAnyCommonLibraryRole())
            router.push({ name: 'NoAccess' });

        return Promise.reject(error);
    }
};
export const errorResponse = ApiErrorInterceptor.errorResponse;
